import Vue from 'vue'

import HowLongAgo from '@/filters/how-long-ago'
import Initials from '@/filters/initials'

export default () => {
  Vue.filter('howLongAgo', HowLongAgo)
  Vue.filter('initials', Initials)
}
